import { null as zNull } from "zod";

export const disconnectKatanaIntegration = {
  name: "disconnectKatanaIntegration" as const,
  input: zNull(),
  output: zNull(),
};
